var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WrapperContent',[_c('b-table',{ref:"tableComponent",attrs:{"header":_vm.header,"headers":_vm.headers,"columns":_vm.columns,"sort":'id',"uri":_vm.tableUri}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }